import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { crmContactModel } from "@/models/crmContactModel";
import KivaProxy from "@/utils/kivaProxy/src";
import { CrmAccountTransformer } from "@/transformers/CrmAccountTransformer";
import { FieldOptionTransformer } from "@/transformers/FieldOptionTransformer";
import { AccountNameTransformer } from "@/transformers/AccountNameTransformer";
import KvCountrySelect from '@/components/kiva/KvCountrySelect';
import KvCitySelect from '@/components/kiva/KvCitySelect';
import KvTownSelect from '@/components/kiva/KvTownSelect';
import KvStateSelect from '@/components/kiva/KvStateSelect';
import optionsMixin from "@/mixins/options";
export default {
  name: "contactForm",
  props: {
    account: [Object],
    forceSaveDirect: Boolean
  },
  mixins: [optionsMixin],
  components: {
    KvCountrySelect: KvCountrySelect,
    KvCitySelect: KvCitySelect,
    KvTownSelect: KvTownSelect,
    KvStateSelect: KvStateSelect
  },
  data: function data() {
    return {
      accountMutable: this.account,
      contactStatuses: [],
      accountTypes: [],
      accountIndustries: [],
      saving: false,
      loading: false,
      slaTotal: 0,
      sla: [],
      slaLevelsTotal: 0,
      slaLevels: []
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.loading = true;
            _context.next = 3;
            return _this.getOptions({
              app: 'crm',
              model: 'account',
              column: 'account_type'
            });
          case 3:
            _context.next = 5;
            return _this.getOptions({
              app: 'crm',
              model: 'account',
              column: 'industry'
            });
          case 5:
            _context.next = 7;
            return _this.getSla();
          case 7:
            _this.loading = false;
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    saveDirect: function saveDirect() {
      var _this2 = this;
      this.saving = true;
      this.$store.commit("savingStart", {
        status: 1
      });
      new KivaProxy({
        endpoint: "crm/account"
      }).update(CrmAccountTransformer.send(this.accountMutable)).then(function (response) {
        _this2.$emit("updateAccount", _this2.accountMutable);
        _this2.saving = true;
        // console.log("response",response)
        _this2.$store.commit("savingEnd", {
          status: 2,
          result: {
            app: 'crm',
            modul: 'deal',
            recordId: _this2.accountMutable.recordId
          }
        });
      }).catch(function (err) {
        _this2.saving = false;
        _this2.$store.commit("savingEnd", {
          status: 3,
          result: {
            app: 'crm',
            modul: 'deal',
            recordId: _this2.accountMutable.recordId
          }
        });
        console.log("err", err);
      });
    },
    getSla: function getSla() {
      var _this3 = this;
      this.loading = true;
      new KivaProxy({
        endpoint: "inbox/sla"
      }).all().then(function (response) {
        _this3.loading = false;
        _this3.slaTotal = response.total;
        _this3.sla = response.records;
        // this.setDefaultSla();
        _this3.getSlaLevels();
      });
    },
    getSlaLevels: function getSlaLevels() {
      var _this4 = this;
      this.loading = true;
      var sla = this.accountMutable.sla && this.accountMutable.sla.value ? this.accountMutable.sla.value : this.accountMutable.sla;
      new KivaProxy({
        endpoint: "inbox/sla_level_configuration"
      }).setFilters({
        sla: ["=", sla]
      }).all().then(function (response) {
        _this4.loading = false;
        _this4.slaLevelsTotal = response.total;
        _this4.slaLevels = response.records;
        // this.setDefaultSlaLevel();
      });
    }
  },

  computed: {
    isEdit: function isEdit() {
      return !!this.data;
    },
    actionButtonText: function actionButtonText() {
      return this.isEdit ? "Save" : "Create";
    }
  },
  watch: {
    forceSaveDirect: function forceSaveDirect(val) {
      this.saveDirect();
      this.$emit("updatesaveDirect", false);
    },
    value: function value(val) {
      this.mutableValue = val;
    },
    mutableValue: function mutableValue(val) {
      if (!val) {
        this.$emit("close");
      }
      this.$emit("input", val);
    },
    data: {
      immediate: true,
      handler: function handler(val) {
        this.contactModel = crmContactModel(val);
      }
    }
  }
};